















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Grades, SearchCondition, EditGrades } from '@/modules/recordList';
import { Subject } from '@/models/subject';
import { SchoolTypes } from '@/enums/schoolTypes';
import { SchoolTerms } from '@/enums/schoolTerms';
import { GradesTypes } from '@/enums/gradesTypes';

@Component
export default class RecordListContent extends Vue {
  private SchoolTypes = SchoolTypes;
  private GradesTypes = GradesTypes;

  @Prop({ required: true }) private type: number;
  @Prop() private isChanged: boolean;

  private showSearchCondition = true;

  private isChangedModel = false;
  private studentsSort: Grades[] = [];

  get loading(): boolean {
    switch (this.type as GradesTypes) {
      case GradesTypes.Report:
        return this.$store.state.recordList.report.loading;
      case GradesTypes.RoutineTest:
        return this.$store.state.recordList.routineTest.loading;
      case GradesTypes.OtherTest:
        return this.$store.state.recordList.otherTest.loading;
      default:
        return this.$store.state.recordList.report.loading;
    }
  }

  get subjects(): Subject[] {
    const students = this.students;
    if (!students || students.length === 0) {
      return [];
    } else {
      return students[0].pointsList.map((item) => {
        return {
          id: item.subject,
          name: item.subjectName,
          color: item.subjectColor,
        };
      });
    }
  }

  get students(): Grades[] {
    switch (this.type as GradesTypes) {
      case GradesTypes.Report:
        return this.$store.state.recordList.report.gradesList;
      case GradesTypes.RoutineTest:
        return this.$store.state.recordList.routineTest.gradesList;
      case GradesTypes.OtherTest:
        return this.$store.state.recordList.otherTest.gradesList;
      default:
        return this.$store.state.recordList.report.gradesList;
    }
  }

  get condition(): SearchCondition {
    switch (this.type as GradesTypes) {
      case GradesTypes.Report:
        return this.$store.state.recordList.report.searchCondition;
      case GradesTypes.RoutineTest:
        return this.$store.state.recordList.routineTest.searchCondition;
      case GradesTypes.OtherTest:
        return this.$store.state.recordList.otherTest.searchCondition;
      default:
        return this.$store.state.recordList.report.searchCondition;
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    try {
      await this.$store.dispatch('recordList/searchGradesList', this.condition);
    } catch (error) {
      throw error;
    }
    this.studentsSort = this.students.slice(0, this.students.length);
  }

  private onChangeCondition() {
    this.loadData();
  }

  private recordCellStyle({ column }: any) {
    switch (column.property) {
      case 'ordinarySchoolName':
      case 'gradeYearName':
      case 'studentName':
        return { cursor: 'pointer' };
      default:
        return null;
    }
  }

  private onCellClick(row: Grades, column: any) {
    switch (column.property) {
      case 'ordinarySchoolName':
      case 'gradeYearName':
      case 'studentName':
        this.$router.push({
          name: 'RecordView',
          params: {
            studentId: row.studentId,
            tab: String(this.type),
            schoolType: String(this.condition.schoolType),
            otherTest: this.type === GradesTypes.OtherTest ? this.condition.testType : ''
          },
        });
        break;
    }
  }

  private onChangeSort({ column, prop, order }: {column: any, prop: string, order: string} ) {
    if (!order) {
      this.studentsSort = this.students.slice(0, this.students.length);
    } else {
      if (!prop) { return; }

      if (prop.indexOf('record-') === 0) {
        const subjectId = Number(prop.slice('record-'.length));
        const sort = (order === 'ascending') ? -1 : 1;

        this.studentsSort = this.studentsSort.sort((a, b) => {
          const record1 = a.pointsList.find((item) => {
            return (item.subject === subjectId);
          });
          const record2 = b.pointsList.find((item) => {
            return (item.subject === subjectId);
          });

          const score1 = !record1 ? null : record1.points;
          const score2 = !record2 ? null : record2.points;

          if (score1 === null && score2 === null) { return 0; }
          if (score1 === null && score2 !== null) { return -1 * sort; }
          if (score1 !== null && score2 === null) { return 1 * sort; }
          if ((score1 as number) < (score2 as number)) { return -1 * sort; }
          if ((score1 as number) > (score2 as number)) { return 1 * sort; }
          return 0;
        });
      }
    }
  }

  private onKeyPressScore(e: KeyboardEvent) {
    const theEvent = e || window.event;
    const key = theEvent.keyCode || theEvent.which;
    if ((key < 48 || key > 57) && !(key === 8 || key === 9 || key === 13 || key === 37 || key === 39)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) {
        theEvent.preventDefault();
      }
    }
  }

  private onChangeScore(row: Grades, subjectId: number, e: any) {
    const record = row.pointsList.find((item) => {
      return (item.subject === subjectId);
    });
    if (!record) {
      return;
    }
    const value = e.currentTarget.value.replace(/[^\d]/, '');
    if (value === '') {
      record.points = null;
    } else {
      const num = Number(value);
      if (isNaN(num)) {
        record.points = null;
      } else {
        record.points = num;
      }
    }
    e.currentTarget.value = record.points;

    row.isRecordChanged = !!row.pointsList.find((item) => {
      return (item.points !== item.beforePoints);
    });
    this.checkChanged();
  }

  private checkChanged() {
    const isChanged = !!this.students.find((item) => {
      return item.isRecordChanged;
    });
    if (this.isChangedModel !== isChanged) {
      this.isChangedModel = isChanged;
      this.$emit('update:isChanged', this.isChangedModel);
    }
  }

  private async onRegist(row: Grades) {
    if (!row.isRecordChanged || row.pointsList.length === 0) { return; }

    // 登録処理
    try {
      const gradesTarget = row.pointsList[0];
      const editData: EditGrades = {
        gradesId: gradesTarget.gradesId,
        gradesCollectionId: gradesTarget.gradesCollectionId,
        studentId: row.studentId,
        gradeYear: gradesTarget.gradeYear,
        schoolTerm: gradesTarget.schoolTerm,
        pointList: row.pointsList.filter((item) => item.points !== item.beforePoints)
          .map((item) => ({
              subject: item.subject,
              points: item.points
            })
          ),
      };
      await this.$store.dispatch('recordList/editGrades', editData);

      row.pointsList.forEach((item) => {
        item.beforePoints = item.points;
      });
      row.isRecordChanged = false;

      this.$notify({
        title: '登録完了',
        message: `生徒『${row.studentName}』の成績を登録しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify({
        title: 'エラー',
        message: `生徒『${row.studentName}』の成績の登録に失敗しました。`,
        position: 'bottom-right'
      });
    }
    this.checkChanged();

    // なぜか登録ボタンがDisableにならない為、再セット
    this.studentsSort = this.studentsSort.slice(0, this.studentsSort.length);
  }
}
